// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"UserProfileIcon_iconContainer__10Lsp"};